<template>
  <div class="mine_right flex_item">
    <div class="mine_rightTop nobt">
      <div class="flex">
        <span class="mine_line"></span>
        <p class="">我的学分</p>
        <!-- <p class="mine_topExp">温馨提示：通过审核的学分管理员会在七个工作日内上传继续教育学分平台，上传成功后学分注册会显示已注册。</p> -->
      </div>
      <div class="mine_tab flex">
        <a href="javascript:;" @click="selectedTab = '全部年度'" class="mine_tabItem"
          :class="selectedTab == '全部年度' ? 'active' : ''">全部年度</a>
        <a href="javascript:;" @click="selectedTab = '2022'" class="mine_tabItem"
          :class="selectedTab == '2022' ? 'active' : ''">2022</a>
        <a href="javascript:;" @click="selectedTab = '2021'" class="mine_tabItem"
          :class="selectedTab == '2021' ? 'active' : ''">2021</a>
        <a href="javascript:;" @click="selectedTab = '2020'" class="mine_tabItem"
          :class="selectedTab == '2020' ? 'active' : ''">2020</a>
        <a href="javascript:;" @click="selectedTab = '2019'" class="mine_tabItem"
          :class="selectedTab == '2019' ? 'active' : ''">2019</a>
        <a href="javascript:;" @click="selectedTab = '2018'" class="mine_tabItem"
          :class="selectedTab == '2018' ? 'active' : ''">2018</a>
      </div>
    </div>
    <div v-if="pointList.length != 0" class="mine_rightBody">
      <div class="xf_table_top">
        <div class="xf_tableTop flex">
          <div class="xf_tableTd">课程名称</div>
          <div class="xf_tableTd">结业日期</div>
          <div class="xf_tableTd flex_item">学分</div>
          <div class="xf_tableTd">继续教育学分注册</div>
        </div>
        <div v-for="(item, index) in pointList" :key="index" class="xf_tableBody flex">
          <div class="xf_tableTd">{{item.courseName}}</div>
          <div class="xf_tableTd">{{item.endTime}}</div>
          <div class="xf_tableTd flex_item">{{item.credit}}分</div>
          <div class="xf_tableTd" :class="statusMsgColorClass(item.registed)">{{item.registed}}</div>
        </div>
      </div>
    </div>
    <div v-if="pointList.length == 0" class="mine_rightBody">
        <div class="listNullTip">
          <img src="../../assets/icon_empty.png" />
          <span>暂无数据</span>
        </div>
      </div>
  </div>
</template>

<script>
import { getPointList } from '../../server/user_center_point';

export default {
  data() {
    return {
      pointList: [],
      selectedTab: "全部年度"
    }
  },
  mounted() {
    this.fetchPointList();
  },
  methods: {
    async fetchPointList() {
      let result = [];
      if (this.selectedTab == "全部年度") {
        result = await getPointList();
      } else {
        result = await getPointList(this.selectedTab);
      }
      this.pointList = result != false ? result : [];
    },
    statusMsgColorClass(status) {
      let cls = "clo_org";
      // clo_org: 注册中;
      // clo_green: 已注册;
      if (status.indexOf("注册中") >= 0) {
        cls = "clo_org";
      } else if (status.indexOf("已注册") >= 0) {
        cls = "clo_green";
      }
      return cls;
    },
  },
  watch: {
    selectedTab: {
      handler() {
        this.fetchPointList();
      }
    }
  }
}
</script>

<style scoped>
.mine_right {
  box-sizing: border-box;
  margin-top: 16px;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

.mine_rightTop {
  padding: 24px 32px;
  border-bottom: 1px solid #F3F3F3;
  background-color: #fff;
}

.mine_rightTop.nobt {
  padding-bottom: 0px;
}

.mine_rightTop p {
  font-size: 28px;
  font-weight: 600;
  color: #222;
}

.mine_rightTop p.mine_topExp {
  font-size: 14px;
  color: #666;
  margin-left: 20px;
  font-weight: 400;
}

.mine_line {
  width: 5px;
  height: 28px;
  background-color: #003399;
  border-radius: 3px;
  margin-right: 20px;
}

.mine_tab {
  margin-top: 40px;
}

.mine_tabItem {
  margin-right: 60px;
  font-size: 16px;
  color: #666;
  line-height: 22px;
  padding-bottom: 30px;
  font-weight: 500;
  position: relative;
}

.mine_tabItem.active {
  color: #222;
  font-weight: bold;
}

.mine_tabItem.active::after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 50%;
  width: 36px;
  margin-left: -18px;
  height: 2px;
  background-color: #003399;
}

.mine_rightBody {
  padding: 16px 32px;
  background-color: #fff;
}

.xf_tableTop {
  background-color: #E1E6EB;
  padding: 13px 0px;
}

.xf_tableTd {
  text-align: center;
  border-right: 1px solid #C7CBCE;
  color: #222;
  font-size: 16px;
  padding: 0px 25px;
}

.xf_tableTd:first-child {
  width: 330px;
}

.xf_tableTd:nth-child(2) {
  width: 178px;
}

.xf_tableTd:last-child {
  width: 208px;
  border: 0px;
}

.xf_tableBody .xf_tableTd {
  padding: 24px 25px;
  border: 0px;
  font-size: 14px;
}

.xf_tableBody .xf_tableTd:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  hyphens: auto;
}

.xf_tableBody {
  border-bottom: 1px solid #E1E6EB;
}

.clo_org {
  color: #FF6100 !important;
}

.clo_green {
  color: #29B28B !important;
}

.listNullTip {
  width: 100%;
  padding-top: 80px;
  padding-bottom: 80px;
}

.listNullTip img {
  display: block;
  margin: 0 auto;
  width: 240px;
  margin-bottom: 9px;
}

.listNullTip span {
  display: block;
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
}
</style>